module.exports = __webpack_public_path__ + "img/error-500.28c10201.svg";